export enum SubunitChannel {
  CREATE = 'subunit::create',
  EDIT = 'subunit::patch',
  DELETE = 'subunit::delete',
}
